// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hv","message":"hw","close":"hx","closeMessage":"hy","closeIcon":"hz"};